import { characterReady } from '@/features/studio-renew/steps'

import type { Character } from '@/features/studio-renew/types'

type Item = {
  id: string
  label: string
  step: 'profile' | 'persona' | 'habits' | 'scenes'
  done: boolean
  points?: number
}
const REQUIRED_COMPLETION = 60

/** 작품과 같은 60/40 작성 가이드다. 선택 항목으로 필수 입력을 대신할 수 없다. */
export function characterCompletion(character: Character) {
  const required: Item[] = [
    {
      id: 'name',
      label: '캐릭터 이름',
      step: 'profile',
      done: !!character.name.trim(),
    },
    {
      id: 'image',
      label: '대표 이미지',
      step: 'profile',
      done: !!character.image.trim(),
    },
    {
      id: 'tagline',
      label: '한 줄 소개',
      step: 'profile',
      done: !!character.tagline.trim(),
    },
    {
      id: 'persona',
      label: '캐릭터 설정',
      step: 'persona',
      done: !!character.persona.trim(),
    },
  ]
  const optional: Item[] = [
    {
      id: 'avatar',
      label: '채팅 프로필 사진',
      step: 'profile',
      points: 10,
      done: !!character.avatar?.trim(),
    },
    {
      id: 'habits',
      label: '말버릇',
      step: 'habits',
      points: 10,
      done: character.habits.some((row) => !!row.text.trim()),
    },
    {
      id: 'scenes',
      label: '캐릭터 상황 이미지',
      step: 'scenes',
      points: 20,
      done: !!character.album?.some(
        (shot) => !!shot.image.trim() && !!shot.situation?.trim()
      ),
    },
  ]
  const ready = characterReady(character)
  const requiredPoints =
    (REQUIRED_COMPLETION * required.filter((item) => item.done).length) /
    required.length
  const optionalPoints = optional.reduce(
    (sum, item) => sum + (item.done ? (item.points ?? 0) : 0),
    0
  )
  const percent = ready
    ? REQUIRED_COMPLETION + optionalPoints
    : Math.min(REQUIRED_COMPLETION - 1, requiredPoints + optionalPoints)
  return {
    required,
    optional,
    ready,
    percent,
    nextStep: required.find((item) => !item.done)?.step ?? 'profile',
  }
}
